import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 41 40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M16.794 32.5v-1.583c0-1.43-1.296-2.749-2.298-3.76C12.983 25.63 12 23.742 12 21.416c0-4.372 3.583-7.917 8-7.917 4.419 0 8 3.545 8 7.917 0 2.326-.983 4.213-2.494 5.74-1.004 1.011-2.308 2.33-2.308 3.76V32.5H23V37l-1.5 1.5h-3L17 37v-4.5zM20 6.5v-6m-7 8-3-5m-2 10-5-3m3 11H0m8 7-5 3m30-3 5 3m-3-10h6m-8-8 5-3m-10-2 3-5"
    }, null, -1)
  ])))
}
export default { render: render }